export default {"src":"/_next/static/media/down-arrow.75a164e6.svg","height":60,"width":76,"blurWidth":0,"blurHeight":0};